import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../utils/cn';
interface FloatingShapeProps {
  type: 'cube' | 'sphere' | 'pyramid';
  color?: string;
  size?: number;
  className?: string;
  delay?: number;
  duration?: number;
}
export function FloatingShape({
  type,
  color = 'bg-primary',
  size = 100,
  className,
  delay = 0,
  duration = 6
}: FloatingShapeProps) {
  return <motion.div initial={{
    y: 0,
    rotate: 0
  }} animate={{
    y: [-20, 20, -20],
    rotate: [0, 180, 360]
  }} transition={{
    duration: duration,
    repeat: Infinity,
    ease: 'easeInOut',
    delay: delay
  }} className={cn('absolute opacity-20 blur-sm pointer-events-none z-0', className)} style={{
    width: size,
    height: size
  }} data-id="element-145">
      {type === 'cube' && <div className={cn('w-full h-full border-2 border-primary/30 rotate-45', color === 'bg-white' ? 'border-white/30' : '')} data-id="element-146" />}
      {type === 'sphere' && <div className={cn('w-full h-full rounded-full border-2 border-primary/30', color === 'bg-white' ? 'border-white/30' : '')} data-id="element-147" />}
      {type === 'pyramid' && <div className={cn('w-0 h-0 border-l-[50px] border-r-[50px] border-b-[100px] border-l-transparent border-r-transparent border-b-primary/30', color === 'bg-white' ? 'border-b-white/30' : '')} data-id="element-148" />}
    </motion.div>;
}